import styled from "styled-components";

const Paper = styled.div`
    padding: 1.5rem 1rem;
    box-shadow: 0px 3px 1px -2px ${(props) => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${(props) => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${(props) => props.theme.colors.black(0.12)};
    background-color: ${(props) => props.theme.colors.white(1)};
    border-radius: 0.3rem;
    cursor: pointer;
    transition: box-shadow 0.3s ease, background-color 0.3s ease;
    user-select: none;
    margin-bottom: 1rem;
    &:hover {
        box-shadow: 0px 2px 4px -1px ${(props) => props.theme.colors.black(0.2)}, 0px 4px 5px 0px ${(props) => props.theme.colors.black(0.14)},
            0px 1px 10px 0px ${(props) => props.theme.colors.black(0.12)};
    }
    &:active {
        background-color: ${(props) => props.theme.colors.white(0.7)};
    }
`;

export default Paper;
